// extracted by mini-css-extract-plugin
export var anchor = "style-module--anchor--cEP57";
export var root = "style-module--root--zt5yI";